function AppearOnScroll() {
	this.build();
}

AppearOnScroll.prototype.build = function () {
	const $items = $('[data-aos]');

	if (window.scrollY > 0) {
		$items.each(function (index, elem) {
			$(elem).addClass('appeared');
		});
	} else {
		$(window).on('transitionDone', function () {
			$items.each(function (index, elem) {
				let delay = elem.dataset.aosDelay || 0;
				ScrollTrigger.create({
					trigger: elem,
					start: 'top bottom',
					once: true,
					onEnter: () => {
						setTimeout(function () {
							$(elem).addClass('appeared');
						}, delay);
					}
				});
			});
		});
	}
};
